import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getSubstitutions(params: any): AxiosPromise {
    return EndPointService.get('/substitutions', { params });
}

function getSubstitution(id: number | string): AxiosPromise {
    return EndPointService.get(`/users/${id}`);
}

function deleteSubstitution(id: number | string): AxiosPromise {
    return EndPointService.delete(`/seances/delete/substitution/${id}`);
}

function createSubstitution(payload: any): AxiosPromise {
    return EndPointService.post('/substitutions', payload);
}

function deleteFileSubstitution(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/user_docs/${fileId}`);
}

function createFilesSubstitution(data: any): AxiosPromise {
    return EndPointService.post(`/user_docs`, data);
}

function getFilesSubstitution(id: string | number): AxiosPromise {
    return EndPointService.get(`/user_docs`, {
        params: {
            'user.id': id,
        },
    });
}

function updateSubstitution(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/substitution/update`, { ...payload, userId: id }, { params: { id } });
}

function patchSubstitution(payload: any): AxiosPromise {
    return EndPointService.put(`/substitution/status`, payload);
}

export default {
    getSubstitutions,
    getFilesSubstitution,
    createFilesSubstitution,
    deleteFileSubstitution,
    getSubstitution,
    deleteSubstitution,
    createSubstitution,
    updateSubstitution,
    patchSubstitution,
};
